import CommonPopup from "..";
import { PublicTermPurpose } from "../../../services/etcServices";

import useTerms from "../../../hooks/useTerms";

import "./common.css";
import "./swiper.min.css";

type Props = { popup: string; onClose: () => void; type: PublicTermPurpose };

export default function TermsPopup({ popup, onClose, type }: Props) {
  const [{ terms }, termsVersionComponent] = useTerms({
    purpose: type,
    onClose,
  });
  return (
    <CommonPopup
      title={
        (terms?.name?.includes("_")
          ? terms?.name?.split("_")[1]
          : terms?.name) ?? " "
      }
      isOpen={popup === "showTerms"}
      onClose={onClose}
      padding={0}
      unUseHorizonRule
    >
      <div className="max-h-[70vh] overflow-y-auto">
        {termsVersionComponent}
      </div>
    </CommonPopup>
  );
}
